// src/theme/colors.ts
var colors = {
  black: "#0D0D0D",
  white: "#FFFFFF",
  salmon: "#FFC7C8",
  olive: "#001814",
  neutral: {
    50: "#F8F8F8",
    75: "#F0F0F0",
    100: "#E3E3E3",
    200: "#CFCFD0",
    300: "#A2A2A6",
    400: "#7E7E83",
    500: "#636469",
    600: "#4E4F53",
    700: "#37363B",
    800: "#262528",
    900: "#181819",
    950: "#181819"
  },
  kale: {
    50: "#EDFCF2",
    100: "#DFF1E4",
    200: "#C2E7C6",
    300: "#74E290",
    400: "#3FCA70",
    500: "#16B15C",
    600: "#0B9354",
    700: "#09774D",
    800: "#095D44",
    900: "#09493C",
    950: "#00362f"
  },
  splice: {
    50: "#F9FFE5",
    100: "#EEFFC8",
    200: "#E3FF93",
    300: "#DBFC45",
    400: "#C6F226",
    500: "#A7D709",
    600: "#7FB102",
    700: "#5C8307",
    800: "#4A690C",
    900: "#3D570F",
    950: "#1D3102"
  },
  sloe: {
    50: "#F0F2FD",
    100: "#E4E7FB",
    200: "#CED2F7",
    300: "#B0B5F1",
    400: "#9191E9",
    500: "#7E74E7",
    600: "#6B58DA",
    700: "#5B46C3",
    800: "#47389F",
    900: "#3D3380",
    950: "#251F4D"
  },
  chilli: {
    50: "#FEF4F2",
    100: "#FDE6E3",
    200: "#FDD1CB",
    300: "#FAB2A7",
    400: "#F68473",
    500: "#EB553F",
    600: "#D94029",
    700: "#B6321F",
    800: "#972D1D",
    900: "#7D2B1F",
    950: "#44120B"
  },
  aioli: {
    50: "#FFFAF3",
    100: "#FFEED5",
    200: "#FED9AA",
    300: "#FDBE74",
    400: "#FB973C",
    500: "#F97916",
    600: "#EA5E0C",
    700: "#C2460C",
    800: "#9A3812",
    900: "#7C3012",
    950: "#431607"
  },
  green: {
    50: "#EAFAE9",
    100: "#CEF2CB",
    200: "#92D791",
    300: "#69BF72",
    400: "#39A256",
    500: "#247736",
    600: "#1D5F2C",
    700: "#194C27",
    800: "#153F21",
    900: "#103017",
    950: "#0C2612"
  },
  blue: {
    50: "#EAF5FF",
    100: "#DFF1FF",
    200: "#B8E3FF",
    300: "#7DD0FF",
    400: "#33B7FD",
    500: "#099EEE",
    600: "#007DCC",
    700: "#0064A5",
    800: "#0A4770",
    900: "#062C4B",
    950: "#04233C"
  },
  // old brand
  burple: {
    50: "#F3F2FF",
    100: "#E9E7FF",
    200: "#D5D2FF",
    300: "#B7AEFF",
    400: "#9380FF",
    500: "#714DFF",
    600: "#6F3DFF",
    700: "#5116EB",
    800: "#4412C5",
    900: "#381C82",
    950: "#381C82"
  },
  margarita: {
    50: "#F9FFE5",
    100: "#EEFFC8",
    200: "#DCFF93",
    300: "#C7F46F",
    400: "#98DC26",
    500: "#6BAD03",
    600: "#518308",
    700: "#3E610C",
    800: "#2D4B06",
    900: "#213206",
    950: "#213206"
  }
};

export {
  colors
};
